import { Button } from "@mui/material";
import "./Contact.css";
import HomeNavbar from "./UI/HomeNavbar";
import { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import {db} from '../firebase';
import ErrorModal from "./UI/ErrorModal";

const Contact = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [query, setQuery] = useState('');
    const [error, setError] = useState('');

    const saveContactFormData = async () => {
        console.log(error);
        if(name === '' || email === '' || subject === '' || query === ''){
            setError('Plz Fill All The Fields! Error: ' + Math.round(Math.random()*1000+1));
            return;
        }
        try {
            const docRef = await addDoc(collection(db, "queries"), {
                name: name,
                email: email,
                subject: subject,
                query: query
              });
              console.log("Document written with ID: ", docRef.id);
              setError('Sent Successfully at ' + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
        } catch (e) {
            setError('Error!!!')
          console.error("Error adding document: ", e);
          return;
        }
        setName('');
        setEmail('');
        setQuery('');
        setSubject('');
      }
    

  return (
    <>
      <HomeNavbar />
      <div className="contact-container">
        <div className="contact-info">
          <h4>CONTACT INFORMATION</h4>
          <table className="contact-table">
            <tr>
              <td className="td-bold">Name: </td>
              <td>Prem Kumar Singh</td>
            </tr>
            <tr>
              <td className="td-bold">Email: </td>
              <td>premkumarsingh410@gmail.com</td>
            </tr>
            <tr>
              <td className="td-bold">Phone: </td>
              <td>+91 12345XXXXX</td>
            </tr>
            <tr>
              <td className="td-bold">Address: </td>
              <td>VIT Vellore</td>
            </tr>
          </table>
        </div>
        <div className="contact-form">
          <h4>Get In Touch</h4>
          <input type="text" name="name" placeholder="First Name" value={name} onChange={(event)=>setName(event.target.value)} required/>
          <h4>Your Email</h4>
          <input type="email" name="email" placeholder="Enter our Email" value={email} onChange={(event)=>setEmail(event.target.value)} required/>
          <input type="text" name="sub" placeholder="Subject" value={subject} onChange={(event)=>setSubject(event.target.value)} required/>
          <input type="text" name="queries" placeholder="Your Queries" value={query} onChange={(event)=>setQuery(event.target.value)} required/>
          <Button
            variant="contained"
            sx={{
              marginBottom: "10px",
              marginLeft: {md: "38px", sx: "0px"},
              width: "150px",
              bgcolor: '#d60fee', ':hover': {bgcolor: '#EF20DA'}
            }}
            onClick={saveContactFormData}
          >
            Submit
          </Button>
        </div>
      </div>
      <ErrorModal errorMsg={error} isError={error} />
    </>
  );
};

export default Contact;
